const cvData = {
  personal: {
    name: "Dr. Öğr. Üyesi Memduh Köse",
    title: "Elektrik-Elektronik Mühendisliği Bölümü",
    university: "Kırşehir Ahi Evran Üniversitesi",
    email: "memduh.kose@ahievran.edu.tr",
    phone: "+90 (386) 280 38 00",
    address: "Kırşehir Ahi Evran Üniversitesi Mühendislik-Mimarlık Fakültesi Elektrik-Elektronik Mühendisliği Bölümü Bağbaşı Yerleşkesi Oda No: Z-24"
  },
  education: [
    {
      degree: "Doktora",
      field: "Elektrik-Elektronik Mühendisliği",
      university: "Ankara Üniversitesi / Fen Bilimleri Enstitüsü",
      year: "2009",
      thesis: "Kablosuz Vericilerin Açılma Geçici Rejim Sinyallerine Dayalı RF Parmak İzleri Kullanılarak Sınıflandırılması",
      advisor: "Ziya Telatar"
    },
    {
      degree: "Yüksek Lisans",
      field: "Elektrik-Elektronik Mühendisliği",
      university: "Ankara Üniversitesi / Fen Bilimleri Enstitüsü",
      year: "1997",
      thesis: "Görüntü Onarmada Pencereleme Teknikleri",
      advisor: "Ziya Telatar"
    },
    {
      degree: "Lisans",
      field: "Elektronik Mühendisliği",
      university: "Ankara Üniversitesi / Mühendislik Fakültesi",
      year: "1992"
    }
  ],
  researchInterests: [
    "RF Parmak İzi (RF Fingerprinting)",
    "IoT Cihaz Kimlik Tespiti",
    "Makine Öğrenmesi",
    "Derin Öğrenme",
    "Elektronik Burun (Electronic Nose)",
    "Gıda Kalite Tespiti",
    "Sinyal İşleme",
    "Arduino ve Sensör Uygulamaları"
  ],
  experience: [
    {
      position: "Doktor Öğretim Üyesi",
      institution: "Kırşehir Ahi Evran Üniversitesi",
      department: "Mühendislik-Mimarlık Fakültesi / Elektrik-Elektronik Mühendisliği Bölümü / Elektronik Anabilim Dalı",
      period: "2019 - Günümüz"
    },
    {
      position: "Uzman",
      institution: "Ahi Evran Üniversitesi",
      department: "Bilgisayar Bilimleri Uygulama ve Araştırma Merkezi (Donanım Sorumlusu, EBYS Sorumlusu, Kalite ve Risk Komisyon Üyesi)",
      period: "2015 - 2019"
    },
    {
      position: "Uzman",
      institution: "Ahi Evran Üniversitesi",
      department: "Rektörlük",
      period: "2010 - 2014"
    },
    {
      position: "Uzman",
      institution: "Ankara Üniversitesi",
      department: "Mühendislik Fakültesi / Elektrik-Elektronik Mühendisliği Bölümü / Devreler ve Sistemler Anabilim Dalı",
      period: "1999 - 2010"
    }
  ],
  administrativeDuties: [
    {
      position: "Arş. Uyg. Merkezi Müdürü",
      institution: "Ahi Evran Üniversitesi / Bilgisayar Bilimleri Uygulama ve Araştırma Merkezi",
      period: "2014 - 2015"
    }
  ],
  languages: [
    { name: "Türkçe", level: "Ana Dil" },
    { name: "İngilizce", level: "İleri Seviye" }
  ]
};

export default cvData;

